export default __webpack_public_path__ + "static/media/tony-pelayo.32f0c54b.png";